import React, { Fragment, Suspense } from "react";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import RouteFocusReset from "../Route/RouteFocusReset";

import Taptop from "./TapTop";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import CustomizerContext from "../_helper/Customizer";
import Loader from "./Loader";

const AppLayout = () => {
  const { layout } = useContext(CustomizerContext);
  const { sidebarIconType } = useContext(CustomizerContext);

  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const sideBarIcon = localStorage.getItem("sidebar_icon_type") || sidebarIconType;

  return (
    <Fragment>
      <RouteFocusReset />
      <Loader />
      <Taptop />
      <div className={`page-wrapper ${layout1}`} sidebar-layout={sideBarIcon} id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          <Sidebar />
          <div className="page-body">
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};
export default AppLayout;
